/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { breakpoints, colors } from "style";
import Icon, { ICON_TYPE, ICON_SIZE } from "components/Icon";

/**
 * CarouselNavigationButton
 */
const CarouselNavigationButton = ({ direction, onClick, disabled = false }) => (
  <button
    css={[styles.button, disabled && styles.disabled]}
    onClick={onClick}
    disabled={disabled}
    aria-label={`Navigate ${direction}`}
  >
    <Icon
      size={ICON_SIZE.large}
      type={direction === "left" ? ICON_TYPE.chevronLeft : ICON_TYPE.chevronRight}
      color={colors.white}
    />
  </button>
);

const styles = {
  button: css`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: ${colors.purpleRainBase};
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    color: ${colors.white};
    z-index: 10;
    flex-shrink: 0;

    @media (max-width: ${breakpoints.mobile}) {
      width: 40px;
      height: 40px;
    }

    &:hover:not(:disabled) {
      background: ${colors.purpleRainDark1};
      transform: scale(1.05);
    }

    &:active:not(:disabled) {
      transform: scale(0.95);
    }
  `,
  disabled: css`
    opacity: 0.3;
    cursor: not-allowed;
    background: ${colors.purpleRainBase};

    &:hover {
      transform: none;
    }
  `,
};

export default CarouselNavigationButton;
